export const Constants = {
	
	httpStatus: {
		NO_CONTENT: 204
	},

	dateFormat: {
		ISO: 'yyyy-MM-dd',
		DATE_FR: 'dd/MM/yyyy'
	}
}